import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const SurveyCompletePage: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        textAlign: 'center',
        padding: '60px 40px',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        maxWidth: '500px',
        width: '90%'
      }}>
        <div style={{ fontSize: '4rem', marginBottom: '20px' }}>&#10003;</div>
        <h1 style={{ color: '#2c5282', margin: '0 0 16px', fontSize: '1.8rem' }}>
          {t('surveyComplete', 'title')}
        </h1>
        <p style={{ color: '#4a5568', fontSize: '1.1rem', lineHeight: 1.6 }}>
          {t('surveyComplete', 'thankYou')}
        </p>
        <p style={{ color: '#4a5568', fontSize: '1.1rem', lineHeight: 1.6 }}>
          {t('surveyComplete', 'submitted')}
        </p>
        <p style={{ color: '#718096', fontSize: '0.9rem', marginTop: '30px' }}>
          {t('surveyComplete', 'canClose')}
        </p>
      </div>
    </div>
  );
};

export default SurveyCompletePage;
